import React from 'react';

const CsrKpiCard = ({ label, value, sub, pending = false }) => (
  <div className="csr-card csr-kpi">
    <span className="csr-kpi__label">{label}</span>
    <span className="csr-kpi__value">{value}</span>
    {sub ? <span className="csr-kpi__sub">{sub}</span> : null}
    {pending ? <span className="csr-chip csr-chip--amber csr-kpi__chip">Pending data</span> : null}
  </div>
);

export default CsrKpiCard;
